export default __webpack_public_path__ + "static/media/bg-qsn.4c9641d2.jpg";